// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 245 ? "component---src-pages-index-tsx" : chunkId) + "-" + {"108":"c652eabcc9546d26bc52","245":"b1bd92536f6b0f7550c5","452":"58285323e3d6e193a3c6"}[chunkId] + ".js";
};